(function(angular){
	'use strict';
	
	angular.module('fileUploadModule', [
		'coreModule',
		'iconModule',
		'ngFileUpload',
		'SharedFilters'
	]);

})(window.angular);